import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-43df084d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-bottom":"-40px"} }, "Adquirir Producto", -1))
const _hoisted_3 = { class: "cards" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "inputProfile" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Coste total", -1))
const _hoisted_10 = { class: "price-discount" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "paypal-button-container-month",
  style: {"z-index":"0"}
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("Muchas gracias por confiar"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" en nosotros.")
], -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { onMounted, ref, Ref } from 'vue';
import PayPalService from '@/services/PayPalService';
import ProfileService from '@/services/ProfileService';
import { loadScript } from '@paypal/paypal-js';
import { useAuth } from '@/store/useAuth';
import CourseService from '@/services/CourseService';
import main from '@/data/main.js';
import { useRoute } from 'vue-router';
import OrderService from '@/services/OrderService';
import OrderI from '@/interfaces/OrderInterface';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyPayment',
  setup(__props) {

const service = new PayPalService();
const userService = new ProfileService();
const store = useAuth();
const data = ref({});
const user = ref({});
const route = useRoute();
const courseService = new CourseService();
const course_id = route.params.id;
const course: Ref<any> = ref({});
const orderService = new OrderService();
const orderDTO: Ref<OrderI> = ref({});

onMounted(async () => {
    if (!store.token) {
        return;
    }

    course.value = await courseService.GetCourse(course_id);
    if (!course.value || !course.value.currency) {
        console.error('El curso o su moneda no están definidos correctamente.');
        return;
    }

    user.value = await userService.MyUser(store.token);

    const paypalSdk = await loadScript({
        clientId: main.PAYPAL_ID_CLIENT,
        currency: course.value.currency.code,
        vault: true
    });

    if (paypalSdk) {
        const paypalButtons = paypalSdk.Buttons;
        if (paypalButtons) {
            paypalButtons({
                createOrder: async function (data, actions) {
                    const rawResponse = await orderService.createOrder(store.token, course.value.id);
                    const response = await rawResponse.json();
                    if (!response.success) {
                        alert("error");
                    }
                    orderDTO.value = response.data;
                    return actions.order.create({
                        intent: 'CAPTURE',
                        purchase_units: [{
                            amount: {
                                currency_code: course.value.currency.code,
                                value: course.value.price
                            }
                        }]
                    });
                },
                onApprove: async function (data, actions) {
                    await orderService.completeOrder(store.token, orderDTO.value.id);
                    window.location.assign(`compra-realizada`);
                },
                onCancel: async function (data, actions) {
                    await orderService.cancelOrder(store.token, orderDTO.value.id);
                    alert("Compra cancelada");
                }
            }).render('#paypal-button-container-month');
        } else {
            console.error('La función Buttons() no está disponible en el objeto PayPalSdk.');
        }
    } else {
        console.error('El objeto PayPalSdk es nulo.');
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("h4", null, _toDisplayString(course.value?.name), 1),
              _hoisted_6,
              _createElementVNode("img", {
                src: course.value?.imageURL,
                alt: "course",
                style: {"max-width":"200px","height":"auto"}
              }, null, 8, _hoisted_7),
              _hoisted_8,
              _hoisted_9,
              _createElementVNode("p", _hoisted_10, _toDisplayString(course.value?.price) + " " + _toDisplayString(course.value?.currency?.symbol), 1)
            ]),
            _hoisted_11,
            _hoisted_12
          ])
        ]),
        _hoisted_13,
        _hoisted_14
      ])
    ]),
    _: 1
  }))
}
}

})